import {saveData, getData, clearData, findByID} from "../db/db_helper"

//load from DB
export const getOnlineDiscounts = async () =>{
    return await getData("discounts") || []
}

export const getOffllineDiscounts = async () =>{
    return await getData("sync_discounts") || []
}

export const getAllDiscounts = async () =>{
    const online = await getOnlineDiscounts()
    const offline = await getOffllineDiscounts()
    const all = [...online, ...offline]
    return all.sort((a, b) => new Date(b.startTime) - new Date(a.startTime));
}

export const getDiscountById = async(id)=>{
    const online = await findByID("discounts", id)
    const offline = await findByID("sync_discounts", id)
    return online || offline || null
}

export const saveDiscounts = async (obj) =>{
    saveData("discounts", obj)
}